import validate from "/app/node_modules/.bun/nuxt@4.6.3+6bfa02352bb9aa1e/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.bun/nuxt@4.6.3+6bfa02352bb9aa1e/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}